import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Level, Title } from 'rbx';
import styled from 'styled-components';

import { SubHeading } from '../../../components/elements';
import { ACLSConsumer } from '../../../utils/aclsContext';
import Can from '../../../utils/Can';

const Wrapper = styled.div`
  padding: 1rem;
  .level:not(:last-child) {
    margin-bottom: 0;
  }
`;

const Header = ({
  heading,
  activeTab,
  placeName,
  loading,
  dealName,
  prev,
  next,
  location,
}) => (
  <Wrapper>
    <Level>
      <Level.Item align="left">
        <Title size={2}>{heading}</Title>
      </Level.Item>
      <Level.Item align="right">
        <Level.Item>
          <Link to="/place-deals" className="button is-light">
            <span>Cancel</span>
          </Link>
        </Level.Item>
        {activeTab === 1 && (
          <Level.Item>
            <button type="button" onClick={prev} className="button is-primary">
              <span>Prev Tab</span>
            </button>
          </Level.Item>
        )}

        <ACLSConsumer>
          {({ apiActions, pageActions }) => (
            <Can
              action={`${
                location.pathname === '/add-place-deal'
                  ? 'create_place_deal'
                  : 'update_place_deal'
              }`}
              apiActions={apiActions}
              pageActions={pageActions}
              yes={() => (
                <Level.Item>
                  <button
                    type="submit"
                    className={`button is-primary ${loading && 'is-loading'}`}
                  >
                    <span>Submit</span>
                  </button>
                </Level.Item>
              )}
            />
          )}
        </ACLSConsumer>

        {activeTab === 0 && (
          <Level.Item>
            <button type="button" onClick={next} className="button is-primary">
              <span>Next</span>
            </button>
          </Level.Item>
        )}
      </Level.Item>
    </Level>
    <SubHeading className="is-size-2">{placeName}</SubHeading>
    <SubHeading className="is-size-2">{dealName}</SubHeading>
  </Wrapper>
);

export default withRouter(Header);
